import React, { Component } from "react";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import { NavLink, Redirect } from "react-router-dom";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      body: "",
      eligardsunumname: "",
      hippurinsunumname: "",
      success: "",
      error: "",
      getuuid: "",
      gettype: "",
      eligarddisabled: false,
      hippurindisabled: false,
      field_group: "",
      count: 180,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleEligardSubmit = this.handleEligardSubmit.bind(this);
    this.handleHippurinSubmit = this.handleHippurinSubmit.bind(this);
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;
    this.setState({
      [key]: value,
    });
  }

  handleEligardSubmit(event) {
    const timestamp = Date.now();
    event.preventDefault();

    var uid = localStorage.getItem("uid");
    var auth = localStorage.getItem("auth");
    var csrf_token = localStorage.getItem("csrf_token");
    // var username = localStorage.getItem('username');
    // var logout_token = localStorage.getItem('logout_token');

    var self = this;

    console.log("Your input value is: " + this.state.eligardsunumname);

    console.log(uid);
    console.log(auth);
    //console.log(username);
    //console.log(logout_token);

    var axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrf_token,
        Authorization: "Basic Zm9jdXM6SDg3MzczMjNu",
      },
    };

    //console.log(timestamp);
    //console.log(auth);

    axios
      .post(
        "https://rarefocusapi.f5proje.com/node/?_format=json",
        {
          type: [{ target_id: "eligard" }],
          title: [{ value: this.state.eligardsunumname }],
          body: [{ value: this.state.body }],
          uid: [{ target_id: uid }],
        },
        axiosConfig
      )
      .then(function (response) {
        //console.log(response);
        //console.log(response.data.uuid["0"].value)

        self.setState({
          gettype: "eligard",
          getuuid: response.data.uuid["0"].value,
          success: "Message sent getuuid",
          error: "",
        });

        var eligard = response.data.uuid["0"].value;
        console.log(eligard);
        axios.post(
          `https://qr.recordatifocus.com/yourls-api.php?signature=4f17d6356e&action=shorturl&format=json&url=https://sorular.recordatifocus.com/eligard/${eligard}&keyword=${eligard}`,
          axiosConfig
        );
      })
      .catch(function (error) {
        var errorResponse = error.response.data.message;
        errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, "<br />");

        self.setState({
          success: "",
          error: errorResponse,
        });
      });

    // geri sayim
    this.inter = setInterval(() => {
      if (this.state.count <= 0) {
        clearInterval(this.inter);
        this.setState({
          sunumageciniz: "Sunuma geçiniz",
        });
      } else {
        this.setState((prevState) => ({ count: prevState.count - 1 }));
      }
    }, 1000);

    self.setState({
      eligarddisabled: true,
    });
  }

  handleColchicumSubmit(event) {
    const timestamp = Date.now();
    event.preventDefault();

    var uid = localStorage.getItem("uid");
    var auth = localStorage.getItem("auth");
    var csrf_token = localStorage.getItem("csrf_token");
    // var username = localStorage.getItem('username');
    // var logout_token = localStorage.getItem('logout_token');

    var self = this;

    console.log("Your input value is: " + this.state.eligardsunumname);

    console.log(uid);
    console.log(auth);
    //console.log(username);
    //console.log(logout_token);

    var axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrf_token,
        Authorization: "Basic Zm9jdXM6SDg3MzczMjNu",
      },
    };

    //console.log(timestamp);
    //console.log(auth);

    axios
      .post(
        "https://rarefocusapi.f5proje.com/node/?_format=json",
        {
          type: [{ target_id: "colchicum" }],
          title: [{ value: this.state.eligardsunumname }],
          body: [{ value: this.state.body }],
          uid: [{ target_id: uid }],
        },
        axiosConfig
      )
      .then(function (response) {
        //console.log(response);
        //console.log(response.data.uuid["0"].value)

        self.setState({
          gettype: "colchicum",
          getuuid: response.data.uuid["0"].value,
          success: "Message sent getuuid",
          error: "",
        });

        var colchicum = response.data.uuid["0"].value;
        console.log(colchicum);
        axios.post(
          `https://qr.recordatifocus.com/yourls-api.php?signature=4f17d6356e&action=shorturl&format=json&url=https://sorular.recordatifocus.com/colchicum/${colchicum}&keyword=${colchicum}`,
          axiosConfig
        );
      })
      .catch(function (error) {
        var errorResponse = error.response.data.message;
        errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, "<br />");

        self.setState({
          success: "",
          error: errorResponse,
        });
      });

    // geri sayim
    this.inter = setInterval(() => {
      if (this.state.count <= 0) {
        clearInterval(this.inter);
        this.setState({
          sunumageciniz: "Sunuma geçiniz",
        });
      } else {
        this.setState((prevState) => ({ count: prevState.count - 1 }));
      }
    }, 1000);

    self.setState({
      eligarddisabled: true,
    });
  }

  handleHippurinSubmit(event) {
    const timestamp = Date.now();
    event.preventDefault();

    var uid = localStorage.getItem("uid");
    var auth = localStorage.getItem("auth");
    var csrf_token = localStorage.getItem("csrf_token");
    // var username = localStorage.getItem('username');
    // var logout_token = localStorage.getItem('logout_token');

    var self = this;

    console.log("Your input value is: " + this.state.hippurinsunumname);

    //console.log(uid);
    //console.log(csrf_token);
    //console.log(username);
    //console.log(logout_token);

    var axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrf_token,
        Authorization: "Basic Zm9jdXM6SDg3MzczMjNu",
      },
    };

    //console.log(timestamp);

    axios
      .post(
        "https://rarefocusapi.f5proje.com/node/?_format=json",
        {
          type: [{ target_id: "hippurin" }],
          title: [{ value: this.state.hippurinsunumname }],
          body: [{ value: this.state.body }],
          uid: [{ target_id: uid }],
        },
        axiosConfig
      )
      .then(function (response) {
        //console.log(response);
        // console.log(response.data.uuid["0"].value)

        self.setState({
          gettype: "hippurin",
          getuuid: response.data.uuid["0"].value,
          hippurindisabled: true,
          success: "Message sent getuuid",
          error: "",
        });

        console.log(response.data.uuid["0"].value);

        var hipuuid = response.data.uuid["0"].value;
        console.log(hipuuid);

        axios.post(
          `https://qr.recordatifocus.com/yourls-api.php?signature=4f17d6356e&action=shorturl&format=json&url=https://sorular.recordatifocus.com/hippurin/${hipuuid}&keyword=${hipuuid}`,
          axiosConfig
        );
      })

      .catch(function (error) {
        var errorResponse = error.response.data.message;
        errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, "<br />");

        self.setState({
          success: "",
          error: errorResponse,
        });
      });

    // geri sayim
    this.inter = setInterval(() => {
      if (this.state.count <= 0) {
        clearInterval(this.inter);
        this.setState({
          sunumageciniz: "Sunuma geçiniz",
        });
      } else {
        this.setState((prevState) => ({ count: prevState.count - 1 }));
      }
    }, 1000);

    self.setState({
      hippurindisabled: true,
    });
  }

  renderUserLinks() {
    var loggedIn = localStorage.getItem("auth");
    if (loggedIn) {
      return (
        <span className="">
          <NavLink
            className="d-none me-2 small link-dark text-decoration-none"
            to="/user/profile"
          >
            <i className="fa fa-user-circle"></i> Hesap
          </NavLink>
          <NavLink
            className="small link-dark text-decoration-none"
            to="/user/logout"
          >
            <i className="fa fa-sign-out"></i> Çıkış
          </NavLink>
        </span>
      );
    } else {
      return (
        <span>
          <NavLink className="" activeClassName="active" to="/user/login">
            <i className="fa fa-sign-in"></i> Giriş
          </NavLink>
        </span>
      );
    }
  }

  renderUserName() {
    var loggedIn = localStorage.getItem("auth");
    if (loggedIn) {
      var userLinkTitle = localStorage.getItem("username");
      return <span>{userLinkTitle}</span>;
    } else {
      var userLinkTitle = localStorage.getItem("username");
      return <span>Kullanici {userLinkTitle}</span>;
    }
  }

  componentDidMount() {
    var uid = localStorage.getItem("uid");
    console.log(uid);
    var self = this;
    this.serverRequest = axios
      .get("https://rarefocusapi.f5proje.com/user/" + uid + "?_format=json", {
        headers: { Authorization: "Basic Zm9jdXM6SDg3MzczMjNu" },
      })
      .then(function (result) {
        self.setState({
          field_group: result.data.field_group["0"].target_id,
        });
      });
    console.log(this.result);
  }

  render() {
    var loggedIn = localStorage.getItem("auth");

    let group;
    let groupname;

    if (this.state.field_group == 1) {
      group = <span>{this.state.field_group} - uroonkoloji</span>;
      groupname = "uroonkoloji";

      return (
        <div className="row top-buffer">
          <Redirect to="/uroonkoloji" />
        </div>
      );
    }
    else if (this.state.field_group == 2) {
      group = <span>{this.state.field_group} - hematoloji</span>;
      groupname = "hematoloji";

      return (
        <div className="row top-buffer">
          <Redirect to="/hematoloji" />
        </div>
      );
    } else if (this.state.field_group == 3) {
      group = <span>{this.state.field_group} - genel</span>;
      groupname = "genel";

      return (
        <div className="row top-buffer">
          <Redirect to="/genel" />
        </div>
      );
    } else if (this.state.field_group == 4) {
      group = <span>{this.state.field_group} - akne</span>;
      groupname = "akne";

      return (
        <div className="row top-buffer">
          <Redirect to="/akne" />
        </div>
      );
    } else if (this.state.field_group == 5) {
      group = <span>{this.state.field_group} - agri</span>;
      groupname = "agri";

      return (
        <div className="row top-buffer">
          <Redirect to="/agri" />
        </div>
      );
    } else {
      group = <span>{this.state.field_group}</span>;
      groupname = "uroonkoloji";

      <div className="row top-buffer">
        <Redirect to="/sdfadfa" />
      </div>;
    }

    if (!loggedIn) {
      return (
        <div className="row top-buffer">
          <Redirect to="/user/login" />
        </div>
      );
    }
  }
}

export default Home;



// WEBPACK FOOTER //
// src/components/home.jsx